module.exports = __webpack_public_path__ + "static/gumtree-paypal-ui-flows.9f220a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/gumtree-paypal/gumtree-paypal-ui-flows.png
// module id = 462
// module chunks = 181503948081111